import { generatePath } from "@routes/utils";

import type { IExtractParams } from "@routes";

const pathBase = `/stores/:storeId/set-user-password/`;

export type IPathBaseParam = IExtractParams<typeof pathBase>;

export const setPassword = {
  post: (param: IPathBaseParam) => generatePath(pathBase, param),
};
